import { SkipNavLink, SkipNavContent } from '@reach/skip-nav';
import React from 'react';
import '@reach/skip-nav/styles.css';

import Css from './css/Css';
import ErrorBoundary from './error/ErrorBoundary';
import Footer from './footer/Footer';
import Header from './header/Header';
import Seo from './seo/Seo';

const Layout = (props) => {
  const {
    title,
    description,
    ogImage,
    ogKeywords,
    children,
    header = 'dark'
  } = props;
  return (
    <ErrorBoundary>
      <SkipNavLink />
      <Css>
        <Seo
          title={title}
          description={description}
          ogImage={ogImage}
          ogKeywords={ogKeywords}
        />
        <Header mode={header} />
        <SkipNavContent />
        {children}
        <Footer />
      </Css>
    </ErrorBoundary>
  );
};

export default Layout;
